export function highlight(
  el,
  { duration = 5000, color = 'rgba(255, 255, 0, 0.6)' } = {}
) {
  if (el.highlightInProgress) return
  el.highlightInProgress = true

  const oldTransition = el.style.transition
  const oldBgColor = el.style.backgroundColor
  const oldComputedBgColor = oldBgColor || getComputedStyle(el).backgroundColor

  el.style.backgroundColor = color
  void el.offsetWidth
  el.style.transition = `background-color ${duration}ms`
  el.style.backgroundColor = oldComputedBgColor

  setTimeout(() => {
    el.style.transition = oldTransition
    el.style.backgroundColor = oldBgColor
    el.highlightInProgress = false
  }, duration)
}
